exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#header_wrap{position:fixed;z-index:10;background:#fff;border-bottom:1px solid rgba(0,0,0,.1)}#header_wrap .inner{max-width:1000px;padding:30px 10px}#app_icon{width:32px;height:32px;left:30px}#app_icon,#project_title{position:absolute;top:50%;transform:translateY(-50%)}#project_title{left:70px;font-size:35px;font-weight:400}.link_button{position:absolute;top:50%;transform:translateY(-50%);padding:7px 10px;color:#0090ff;background:#fff;border:1px solid #0090ff;font-size:15px;font-weight:600;border-radius:6px}#download_link{right:160px}#view_in_itunes{right:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f4ec7d8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header.vue
// module id = 35
// module chunks = 0